import placeHolder from '../assets/images/image.png';

export default {
    state: {
        imgStub: placeHolder,
    },

    mutations: {
    },

    actions: {
    },

    getters: {
        img_stub: state => state.imgStub,
    },
};